import React from 'react'
import moment from 'moment'
import { Badge } from '@/components/ui/badge'
import store from '../../state/store'

const BADGE_LABELS = {
  priority: 'Priority',
  in_placement: 'In placement',
  in_proposed: 'Tutor selection',
  tutor_selected: 'Tutor selected',
  paid: 'Paid',
  deactivated: 'Deactivated',
  handed_over: 'Handed over',
  lp_deactivated: 'LP closed',
  converted: 'Converted',
  scheduled_call: 'Call booked',
}

const BADGE_VARIANTS = {
  priority: 'destructive',
  in_placement: 'warning',
  in_proposed: 'warning',
  tutor_selected: 'success',
  paid: 'success',
  deactivated: 'secondary',
  handed_over: 'info',
  lp_deactivated: 'secondary',
  converted: 'success',
  scheduled_call: 'info',
}

const StatusBadge = ({ kind, label }) => (
  <Badge variant={BADGE_VARIANTS[kind] || 'secondary'}>
    {label || BADGE_LABELS[kind] || kind}
  </Badge>
)

class PipelineTable extends React.Component {
  onRowClick = (row) => {
    store.emit('pipeline:row:open', row)
  }

  renderRow = (row) => {
    const learners = (row.learners && row.learners.length) ? row.learners.join(', ') : '—'
    const subject = row.subject || (row.source_type === 'Sales::Lead' ? 'Lead' : '—')
    const last_contact = row.last_contact_at ? moment(row.last_contact_at).fromNow() : '—'
    const due = row.due_at ? moment(row.due_at).format('YYYY-MM-DD') : '—'

    const rowClass =
      'cursor-pointer ' +
      (row.in_backlog ? 'shadow-[inset_3px_0_0_var(--primary)]' : '')

    return (
      <tr key={row.journey_key} className={rowClass} onClick={() => this.onRowClick(row)}>
        <td>
          <div className="flex items-center gap-2.5">
            {row.customer_image ? (
              <img
                src={row.customer_image}
                alt=""
                className="size-8 rounded-full object-cover"
              />
            ) : null}
            <div>
              <div className="font-medium text-foreground">{row.customer_name || '—'}</div>
              <div className="text-[11px] text-muted-foreground">
                {row.source_type === 'Sales::Lead' ? 'Lead' : `Enquiry #${row.source_id}`}
                {row.lesson_plan_id ? ` · LP #${row.lesson_plan_id}` : ''}
              </div>
            </div>
          </div>
        </td>
        <td>{learners}</td>
        <td>{subject}</td>
        <td>{row.medium || '—'}</td>
        <td>{row.manager ? row.manager.name : <em>unclaimed</em>}</td>
        <td>{last_contact}</td>
        <td>{due}</td>
        <td>
          <div className="flex flex-wrap gap-1">
            {row.badges && row.badges.length
              ? row.badges.map((b) => (
                  <StatusBadge
                    key={b}
                    kind={b}
                    label={b === 'scheduled_call' && row.scheduled_call_at
                      ? `Call ${moment(row.scheduled_call_at).calendar()}`
                      : null}
                  />
                ))
              : null}
          </div>
        </td>
      </tr>
    )
  }

  render() {
    return (
      <table className="data-table data-table--compact data-table--clickable mb-0 text-[13px] [&_td]:align-middle">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Learner(s)</th>
            <th>Subject</th>
            <th>Medium</th>
            <th>Manager</th>
            <th>Last contact</th>
            <th>Due</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {this.props.rows.map(this.renderRow)}
        </tbody>
      </table>
    )
  }
}

export default PipelineTable
